import I18n from 'I18n';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useCallback, useMemo } from 'react';
import useFetchUserInfo from '../../hooks/useFetchUserInfo';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const BaseCheckboxComponent = baseCheckboxProps => {
  const {
    reportGetter,
    reportSetter,
    getIsReportValidForCheckbox,
    children,
    description,
    descriptionLayout,
    disabledReasonGetter
  } = baseCheckboxProps;
  const WrappedComponent = props => {
    const {
      report,
      onChange,
      disabled
    } = props;
    const userInfo = useFetchUserInfo();
    const {
      isDisabled,
      disabledReason
    } = disabledReasonGetter ? disabledReasonGetter(report) : {
      isDisabled: disabled,
      disabledReason: I18n.text('report-customization-components.disabledGeneric')
    };
    const isChecked = useMemo(() => {
      return reportGetter(report);
    }, [report]);
    const onCheckboxChange = useCallback(({
      target: {
        checked
      }
    }) => {
      onChange(reportSetter(report, checked));
    }, [onChange, report]);
    if (!getIsReportValidForCheckbox({
      report,
      userInfo
    })) {
      return null;
    }
    return /*#__PURE__*/_jsx(Checkbox, {
      description: description,
      descriptionLayout: descriptionLayout,
      checked: isChecked,
      onChange: onCheckboxChange,
      disabled: isDisabled,
      "data-test-id": props['data-test-id'],
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: disabledReason,
        children: children
      })
    });
  };
  return WrappedComponent;
};
export default BaseCheckboxComponent;